<div class="headline">
  <span class="mat-h1 m0">Textmuster</span>
  @if (authService.isLoggedIn() && (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID')) {
    <span class="editing-group">
      @if (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID') {
        <button (click)="toggleSelectMode()" [attr.aria-pressed]="selectMode"
                aria-label="Einträge für Sammelmappen auswählen"
                class="header-buttons" color="primary" mat-flat-button>
          <mat-icon>{{ selectMode ? 'close' : 'create_new_folder' }}</mat-icon>
          <mat-label class="home-new-word-bt-text">{{ selectMode ? 'Auswahl beenden' : 'Sammelmappe' }}</mat-label>
        </button>
      }
      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="sendExportTextPatternsRequest()"
                aria-label="Button to export all text patterns"
                class="header-buttons" color="accent" mat-flat-button>
          <mat-icon>share</mat-icon>
          <mat-label class="home-new-word-bt-text"> Vollständiger Export</mat-label>
        </button>
      }
      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="openNewTextPatternDialog()"
                aria-label="Button to add a new category" class="header-buttons"
                color="primary" mat-flat-button>
        <mat-icon>add</mat-icon>
        <mat-label class="home-new-word-bt-text">Neues Textmuster</mat-label>
      </button>
      }

      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="toggleEditingTools(true)"
                aria-label="Button to disable editing"
                class="editing-buttons header-buttons" mat-flat-button>
          <mat-icon>remove_red_eye</mat-icon>
          <mat-label class="home-new-word-bt-text">Ansicht</mat-label>
        </button>
      }

      @if (displayEditingTools === false && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="toggleEditingTools(true)"
                aria-label="Button to enable editing"
                class="editing-buttons header-buttons" mat-flat-button>
          <mat-icon>edit</mat-icon>
          <mat-label class="home-new-word-bt-text">Bearbeiten</mat-label>
        </button>
      }
    </span>

  }
</div>
<hr>
<div class="main-content-wrapper">
  <mat-chip-listbox aria-label="mode-filter" style="margin-bottom: 7px" [selectable]="true">
    <mat-chip-option [selected]="filterOral" (click)="updateChipOral()">nur mündliche Textmuster</mat-chip-option>
    <mat-chip-option [selected]="filterWritten" (click)="updateChipWritten()">nur schriftliche Textmuster</mat-chip-option>
  </mat-chip-listbox>
  @if (selectMode && canUseFolders) {
    <div class="selection-bar">
      @if (selectedIds.size > 0) {
        <button (click)="selectedIds.clear()" matButton="outlined">Auswahl aufheben</button>
      } @else {
        <span class="gray">Wählen Sie Einträge aus, um sie einer Sammelmappe hinzuzufügen.</span>
      }
      <span class="selection-actions">
        @if (selectedIds.size > 0) {
          <span>{{ selectedIds.size }} {{ selectedIds.size === 1 ? 'Eintrag' : 'Einträge' }} ausgewählt</span>
        }
        <button (click)="addSelectionToFolder()" [disabled]="selectedIds.size === 0" color="primary" mat-flat-button>
          <mat-icon>create_new_folder</mat-icon>
          Zu Sammelmappe hinzufügen
        </button>
      </span>
    </div>
  }
  <div class="custom-scrollbar mat-elevation" id="word-table-wrapper" style="overflow-x: auto;">
    <table [dataSource]="textPatterns" class="w100" mat-table matSort matSortActive="created" matSortDirection="desc"
           matSortDisableClear multiTemplateDataRows>
      <ng-container matColumnDef="select">
        <th *matHeaderCellDef class="select-cell" mat-header-cell>
          <mat-checkbox (change)="togglePage($event.checked)" [checked]="isPageSelected()"
                        [indeterminate]="isPagePartlySelected()" aria-label="Alle Einträge der Seite auswählen"></mat-checkbox>
        </th>
        <td *matCellDef="let element" class="select-cell" mat-cell>
          <mat-checkbox (change)="toggleSelection(element.id, $event.checked)" [checked]="selectedIds.has(element.id)"
                        aria-label="Eintrag für Sammelmappe auswählen"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Wort Column -->
      <ng-container id="pattern-name-col" matColumnDef="name">
        <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Eintrag</th>
        <td *matCellDef="let element" mat-cell>{{ element.name }}</td>
      </ng-container>

      <ng-container id="pattern-mode-col" matColumnDef="mode">
        <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Modus</th>
        <td *matCellDef="let element" mat-cell>{{ translateMode(element.mode) }}</td>
      </ng-container>

      <ng-container id="pattern-mode-col" matColumnDef="delete">
        <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header> Löschen</th>
        <td *matCellDef="let element" mat-cell>
          <span>
            <button
              (click)="delete(element)"
              color="warn"
              mat-icon-button
              matTooltip="Wort löschen"
              matTooltipShowDelay="1000"
              matTooltipPosition="right"
              matTooltipHideDelay="200">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="details">
        <th *matHeaderCellDef mat-header-cell> Details</th>
        <td *matCellDef="let element" mat-cell>
          @if (authService.isLoggedIn()) {
            <button routerLink="/textmuster/{{element.id}}" mat-icon-button>
              <mat-icon>open_in_new</mat-icon>
            </button>
          } @else {
            <button mat-icon-button (click)="openRegisterPopup()">
              <mat-icon>open_in_new</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let element; columns: columns;" class="element-row">
      </tr>
    </table>
    <mat-paginator [length]="resultsLength" [pageSizeOptions]="[10, 25, 50]" [pageSize]="20"
                   showFirstLastButtons></mat-paginator>
  </div>
</div>
